import jsRsasign from 'jsrsasign';

// Convert a hex string to a byte array
function hexToBytes(hex) {
    for (var bytes = [], c = 0; c < hex.length; c += 2)
        bytes.push(parseInt(hex.substr(c, 2), 16));
    return bytes;
}

// Convert a byte array to a hex string
function bytesToHex(bytes) {
    for (var hex = [], i = 0; i < bytes.length; i++) {
        hex.push((bytes[i] >>> 4).toString(16));
        hex.push((bytes[i] & 0xF).toString(16));
    }
    return hex.join("");
}

const rsaFn = {
    encrypt(pk, plaintext) { // prik-私钥   plaintext-需要加密的内容
        // 加密
        var puk = new jsRsasign.RSAKey();
        puk = jsRsasign.KEYUTIL.getKey(pk);
        try {
            // var lt = "";
            var ct = "";
            //RSA每次加密117bytes，需要辅助方法判断字符串截取位置
            //1.获取字符串截取点
            var bytes = new Array();
            bytes.push(0);
            var byteNo = 0;
            var len, c;
            len = plaintext.length;
            var temp = 0;
            for (let i = 0; i < len; i++) {
                c = plaintext.charCodeAt(i);
                if (c >= 0x010000 && c <= 0x10FFFF) {
                    byteNo += 4;
                } else if (c >= 0x000800 && c <= 0x00FFFF) {
                    byteNo += 3;
                } else if (c >= 0x000080 && c <= 0x0007FF) {
                    byteNo += 2;
                } else {
                    byteNo += 1;
                }
                if ((byteNo % 117) >= 114 || (byteNo % 117) == 0) {
                    if (byteNo - temp >= 114) {
                        bytes.push(i);
                        temp = byteNo;
                    }
                }
            }
            //2.截取字符串并分段加密
            if (bytes.length > 1) {
                for (let i = 0; i < bytes.length - 1; i++) {
                    var str;
                    if (i == 0) {
                        str = plaintext.substring(0, bytes[i + 1] + 1);
                    } else {
                        str = plaintext.substring(bytes[i] + 1, bytes[i + 1] + 1);
                    }
                    var t1 = jsRsasign.KJUR.crypto.Cipher.encrypt(str, puk);
                    ct += t1;
                }

                if (bytes[bytes.length - 1] != plaintext.length - 1) {
                    var lastStr = plaintext.substring(bytes[bytes.length - 1] + 1);
                    ct += jsRsasign.KJUR.crypto.Cipher.encrypt(lastStr, puk);
                }
                // console.log(jsRsasign.hextob64(ct))
                return jsRsasign.hextob64(ct);
            }
            var t = jsRsasign.KJUR.crypto.Cipher.encrypt(plaintext, puk);
            var y = jsRsasign.hextob64(t);
            // console.log(y)
            return y;
        } catch (ex) {
            return false;
        }
    },
    decrypt(prik, ciphertext) { // prik-私钥   ciphertext-java加密的密文
        // 解密
        var prv = new jsRsasign.RSAKey();
        prv = jsRsasign.KEYUTIL.getKey(prik);
        // var maxLength = ((k.n.bitLength()+7)>>3);
        var MAX_DECRYPT_BLOCK = 128;
        try {
            var ct = "";
            var t1;
            var bufTmp;
            var hexTmp;
            var str = jsRsasign.b64utohex(ciphertext);
            var buf = hexToBytes(str);
            var inputLen = buf.length;
            //开始长度
            var offSet = 0;
            //结束长度
            var endOffSet = MAX_DECRYPT_BLOCK;

            //分段加密
            while (inputLen - offSet > 0) {
                if (inputLen - offSet > MAX_DECRYPT_BLOCK) {
                    bufTmp = buf.slice(offSet, endOffSet);
                    hexTmp = bytesToHex(bufTmp);
                    t1 = jsRsasign.KJUR.crypto.Cipher.decrypt(hexTmp, prv);
                    ct += t1;

                } else {
                    bufTmp = buf.slice(offSet, inputLen);
                    hexTmp = bytesToHex(bufTmp);
                    t1 = jsRsasign.KJUR.crypto.Cipher.decrypt(hexTmp, prv);
                    ct += t1;

                }
                offSet += MAX_DECRYPT_BLOCK;
                endOffSet += MAX_DECRYPT_BLOCK;
            }
            // console.log(ct)
            return ct;
        } catch (ex) {
            return false;
        }
    },
    autograph(prik, data) { // pk-公钥  data-明文数据
        // 签名
        let signature = new jsRsasign.KJUR.crypto.Signature({
            alg: "MD5withRSA",
            prvkeypem: prik
        }); //!这里指定 私钥 pem!
        signature.updateString(data);
        let a = signature.sign();
        let sign = jsRsasign.hextob64(a);
        // console.log(sign);
        return sign;
    },
    checkSign(pk, data, autograph) { // pk-公钥  data-返回数据,明文  autograph-java生成的签名
        // 验签
        // console.log(pk, data, autograph)
        let signatureVf = new jsRsasign.KJUR.crypto.Signature({
            alg: "MD5withRSA",
            prvkeypem: pk
        });
        signatureVf.updateString(data);
        // !接受的参数是16进制字符串!
        let flag = signatureVf.verify(jsRsasign.b64utohex(autograph));
        // flag 结果为 false/true
        // console.log(flag)
        return flag;
    }
}

export default rsaFn;